import React from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup, Button, Tooltip } from 'reactstrap'
import styles from './TextStylesSlatePlugin.scss'
import { hasTextStyles, hasTextStyle, onClickButton, styleTypes } from './TextStylesSlatePluginContainer'

class TextStylesButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }

    this.onClicks = {}
    styleTypes.map(styleType => {
      this.onClicks[styleType] = this.onStyle.bind(this, styleType)
    })
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  onStyle (styleType, e) {
    return this.props.onChange(onClickButton(e, this.props.state, styleType))
  }

  render () {
    const { state: editorState } = this.props
    const isActive = hasTextStyles(editorState)

    const buttonStyles = {
      Serif: {fontFamily: 'serif'},
      Light: {fontWeight: 'lighter'},
      Caption: {color: 'grey'}
    }

    return (
      <Button
        id={'TextStylesButton' + this.uid}
        color={isActive ? 'primary' : 'secondary'}
        className={styles.TextStylesButton}
      > Styles
        {
          process.env.NODE_ENV !== 'test' &&
          <Tooltip placement='top' isOpen={this.state.tooltipOpen}
            autohide={false}
            target={'TextStylesButton' + this.uid} toggle={this.toggle}>
            <ButtonGroup vertical style={{margin: '8px'}}>
              {styleTypes.map(styleType =>
                <Button key={styleType}
                  style={buttonStyles[styleType]}
                  color={hasTextStyle(editorState, styleType) ? 'primary' : 'secondary'}
                  onClick={this.onClicks[styleType]}>{styleType}
                </Button>
              )}
            </ButtonGroup>
          </Tooltip>
        }
      </Button>
    )
  }
}

TextStylesButton.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default TextStylesButton



// WEBPACK FOOTER //
// ./src/components/TextStylesSlatePlugin/TextStylesButton.js